import { MatStepperIntl } from '@angular/material/stepper';

export function getMatStepperIntl() {
    const matStepperIntl = new MatStepperIntl();
    matStepperIntl.optionalLabel = '';
    
    return matStepperIntl;
  }